<template>
  <!-- Views/Tabs container -->

  <f7-page @page:beforein="onPageBeforeIn" no-swipeback name="online-cs" class="online-cs-info">
    <!-- 在线客服popup -->
    <f7-popup v-show="showOnlineCustomPopup" class="onlineCustom-popup" :opened="onlinePopupOpened" @popup:open="openOnlineCustomPopup" @popup:close="closeOnlineCustomPopup">
      <f7-page>
        <f7-navbar :title="$t('app_0016')">
          <f7-nav-right>
            <f7-link popup-close><i class="f7-icons">multiply_circle</i></f7-link>
          </f7-nav-right>
        </f7-navbar>
        <iframe :src="onlineCustomUrl" class="iframe-onlineCustom" frameborder="0"></iframe>
      </f7-page>
    </f7-popup>
    <f7-navbar :no-hariline="true" innerClass="inner-bankInfo">
      <!-- <f7-nav-left>
            <f7-link @click="back">
              <i class="f7-icons">chevron_left</i>
            </f7-link>
          </f7-nav-left> -->
      <f7-nav-title>{{ $t("app_0008") }}</f7-nav-title>
    </f7-navbar>
    <template>
      <div class="qaimg">
        <ul>
          <li>
            <img class="button-single" src="../../../static/images/yt999/qa.png" />
          </li>
        </ul>
        <div class="curr-time">{{ utcMinusFourTime }}</div>
        <div class="list inset button-save">
          <ul>
            <li>
              <a href="#" class="list-button button-single" @click="openServiceAction()" click="QASubmit">
                <span class="material-icons" style="color: var(--f7-button-text-color); vertical-align: sub">headset_mic</span>
                <span style="display: inline-block">{{ $t("app_0008") }}</span>
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div class="block accordion-list">
        <div class="accordion-item" v-for="item in depositqaList" :key="item.QID">
          <div class="accordion-item-toggle">
            <div class="row no-gap">
              <div class="col-90 text-left col-title" style="padding: 10px; width: 100%">
                <img class="help" src="../../../static/images/yt999/help.png" />
                <div class="s-title">{{ item.CnName_Title }}</div>
              </div>
            </div>
          </div>
          <div class="accordion-item-content">
            <div block class="ans" style="margin: 5px 10px 20px 5px; word-break: break-all; word-wrap: break-word; width: 84%; margin: auto; margin-bottom: 20px">{{ item.CnName_Answer }}</div>
          </div>
        </div>
      </div>
    </template>
  </f7-page>
</template>
<script>
import { depositqalist, getInfo } from "../../../axios/api";
import { mapGetters } from "vuex";
import moment from "moment";
import { getCookie } from "../../../config/utils";
let self;
export default {
  components: {},
  props: {},
  data() {
    return {
      intervalId: null,
      utcMinusFourTime: "",
      depositqaList: [],
      memberBankCardList: [],
      onlinePopupOpened: false,
      onlineCustomUrl: "",
      SureNameFlag: false,
      baseInfo: {},
      showOnlineCustomPopup: true,
    };
  },
  watch: {},
  computed: {
    ...mapGetters(["getMerchantInfo", "onlineCustomLoaded"]),
  },
  methods: {
    updateTime() {
      const date = new Date();
      const offset = -5 * 60;
      const utcMinusFourDate = new Date(date.getTime() + offset * 60000);
      const formattedTime = this.formatDate(utcMinusFourDate);

      this.utcMinusFourTime = formattedTime + " (UTC-5)";
    },
    formatDate(date) {
      const options = {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: true,
        timeZone: "UTC",
      };
      return date.toLocaleString("en-US", options).replace(",", "");
    },
    onError(e) {
      console.log(e);
    },
    getMerchantInfoDetail() {
      const self = this;
      getInfo().then((data) => {
        if (data.Code === "NoError" && data.Data) {
          self.baseInfo = data.Data.BaseInfo;
        }
      });
    },
    getDepositQAListEvent() {
      const self = this;
      depositqalist().then((data) => {
        if (data.Code === "NoError") {
          self.depositqaList = data.Data;
        }
      });
    },
    onlineCustomService() {
      const self = this;
      self.$f7.actions.close(".actions-qq");
      self.$f7.actions.close(".actions-wechat");
      self.onlinePopupOpened = true;
    },
    back() {
      this.$f7router.back();
    },
    onPageBeforeIn() {
      const self = this;
      self.$nextTick(() => {
        self.$f7.emit("myCustomEvent", "online-cs");
      });
    },
    openServiceAction() {
      const self = this;
      // var aa = self.yesterday_md_r();
      // return;
      const baseInfo = self.baseInfo;
      if (baseInfo.CSType == 2) {
        if (!this.onlineCustomLoaded) {
          let loading = self.$f7.dialog
            .create({
              title: "",
              text: "Loading...",
              cssClass: "dialog-preloadgame",
            })
            .open();
          setTimeout(() => {
            loading.close();
            this.openServiceAction();
          }, 1500);
        } else {
          window.Tawk_API.toggle();
        }
      } else {
        self.onlineCustomUrl = baseInfo.MobileService;
        //self.onlinePopupOpened = true;
        var loginName = getCookie("LoginName");
        //console.log(loginName);
        if (loginName == null || loginName == "" || loginName == undefined) {
          window.open(self.onlineCustomUrl, "_blank");
        } else {
          var userInfos = { uid: loginName };
          var params = JSON.stringify(userInfos);
          self.onlineCustomUrl = self.onlineCustomUrl + "&userInfo=" + params;
          window.open(self.onlineCustomUrl, "_blank");
        }
      }
    },
    checkOOC() {
      var today = new Date();
      console.log(today);
      var localOffset = today.getTimezoneOffset();
      var utcMinusFour = today.getTime() - 4 * 60 * 60 * 1000 + localOffset * 60 * 1000;

      var utcMinusFourDate = new Date(utcMinusFour);
      console.log(utcMinusFourDate);

      var year = utcMinusFourDate.getFullYear();
      var month = this.padZero(utcMinusFourDate.getMonth() + 1);
      var day = this.padZero(utcMinusFourDate.getDate());
      var dateStr = year + "-" + month + "-" + day;

      var startDate = dateStr + " 00:00:00";
      var endDate = dateStr + " 23:59:59";
      var date = { StartDate: null, EndDate: null };
      date.StartDate = startDate;
      date.EndDate = endDate;
      return date;
    },
    padZero(num) {
      return num < 10 ? "0" + num : num;
    },
    yesTerDay_MD() {
      var today = new Date();
      console.log(today);
      var localOffset = today.getTimezoneOffset(); // 获取本地时区偏移量，单位是分钟
      var utcMinusFour = today.getTime() - 4 * 60 * 60 * 1000 + localOffset * 60 * 1000;

      var utcMinusFourDate = new Date(utcMinusFour);
      console.log(utcMinusFourDate);
      utcMinusFourDate.setDate(utcMinusFourDate.getDate() - 1); // 减去指定天数

      var year = utcMinusFourDate.getFullYear();
      var month = this.padZero(utcMinusFourDate.getMonth() + 1);
      var day = this.padZero(utcMinusFourDate.getDate());
      var dateStr = year + "-" + month + "-" + day;
      var startDate = dateStr + " 00:00:00";
      var endDate = dateStr + " 23:59:59";
      var date = { StartDate: null, EndDate: null };
      date.StartDate = startDate;
      date.EndDate = endDate;
      console.log(date);
      return date;
    },
    thisWeek_MD() {
      //获取今天
      var nowDate = new Date(); //当天日期
      console.log(nowDate);
      var localOffset = today.getTimezoneOffset(); // 获取本地时区偏移量，单位是分钟
      var utcMinusFour = today.getTime() - 4 * 60 * 60 * 1000 + localOffset * 60 * 1000;
      nowDate = new Date(utcMinusFour);
      console.log(nowDate);

      //今天是本周的第几天
      var nowDayOfWeek = nowDate.getDay();
      //当前日
      var nowDay = nowDate.getDate();
      //当前月
      var nowMonth = nowDate.getMonth();
      //当前年
      var nowYear = nowDate.getFullYear();
      nowYear += nowYear < 2000 ? 1900 : 0; //
      var lastMonthDate = new Date(); //上月日期
      lastMonthDate.setDate(1);
      lastMonthDate.setMonth(lastMonthDate.getMonth() - 1);
      if (nowDayOfWeek == 0) {
        nowDayOfWeek = 7;
      }
      var getWeekStartDate = new Date(nowYear, nowMonth, nowDay - (nowDayOfWeek - 1));

      var date = { StartDate: null, EndDate: null };
      date.StartDate = formatDate_MD_Week(getWeekStartDate, 1, type);
      date.EndDate = formatDate_MD_Week_End(date.StartDate, type);
      console.log(date);
      return date;
    },
    toDay_MD_R() {
      var today = new Date();
      console.log(today);
      var localOffset = today.getTimezoneOffset(); // 获取本地时区偏移量，单位是分钟
      var utcMinusFour = today.getTime() - 4 * 60 * 60 * 1000 + localOffset * 60 * 1000;

      var utcMinusFourDate = new Date(utcMinusFour);
      console.log(utcMinusFourDate);
      utcMinusFourDate.setDate(utcMinusFourDate.getDate()); // 减去指定天数

      var year = utcMinusFourDate.getFullYear();
      var month = this.padZero(utcMinusFourDate.getMonth() + 1);
      var day = this.padZero(utcMinusFourDate.getDate());
      var dateStr = year + "-" + month + "-" + day;

      var startDate = dateStr;
      var endDate = dateStr;
      var date = { StartDate: null, EndDate: null };
      date.StartDate = startDate;
      date.EndDate = endDate;
      console.log(date);
      return date;
    },
    yesTerDay_MD_R(date, type) {
      var today = new Date();
      console.log(today);
      var localOffset = today.getTimezoneOffset(); // 获取本地时区偏移量，单位是分钟
      var utcMinusFour = today.getTime() - 4 * 60 * 60 * 1000 + localOffset * 60 * 1000;

      var utcMinusFourDate = new Date(utcMinusFour);
      console.log(utcMinusFourDate);
      utcMinusFourDate.setDate(utcMinusFourDate.getDate() - 1); // 减去指定天数

      var year = utcMinusFourDate.getFullYear();
      var month = this.padZero(utcMinusFourDate.getMonth() + 1);
      var day = this.padZero(utcMinusFourDate.getDate());
      var dateStr = year + "-" + month + "-" + day;
      var startDate = dateStr;
      var endDate = dateStr;
      var date = { StartDate: null, EndDate: null };
      date.StartDate = startDate;
      date.EndDate = endDate;
      console.log(date);
      return date;
    },
    thisMonth_MD(date, type) {
      //获取今天
      var nowDate = new Date(); //当天日期
      console.log(nowDate);
      var localOffset = today.getTimezoneOffset(); // 获取本地时区偏移量，单位是分钟
      var utcMinusFour = today.getTime() - 4 * 60 * 60 * 1000 + localOffset * 60 * 1000;
      nowDate = new Date(utcMinusFour);
      console.log(nowDate);
      //当前日
      var nowDay = nowDate.getDate();
      //当前月
      var nowMonth = nowDate.getMonth();
      //当前年
      var nowYear = nowDate.getFullYear();
      nowYear += nowYear < 2000 ? 1900 : 0; //
      var lastMonthDate = new Date(); //上月日期
      lastMonthDate.setDate(1);
      lastMonthDate.setMonth(lastMonthDate.getMonth() - 1);
      //获得本月的开始日期
      var getMonthStartDate = new Date(nowYear, nowMonth, nowDay);
      date.StartDate = formatDate_MD_Month(getMonthStartDate, type);

      //获得本月的结束日期
      date.EndDate = formatDate_MD_Month_End(date.StartDate, type);
      console.log(date);
      return date;
    },
    thisMonth_MD_R(date, type) {
      //获取今天
      var nowDate = new Date(); //当天日期
      console.log(nowDate);
      var localOffset = today.getTimezoneOffset(); // 获取本地时区偏移量，单位是分钟
      var utcMinusFour = today.getTime() - 4 * 60 * 60 * 1000 + localOffset * 60 * 1000;
      nowDate = new Date(utcMinusFour);
      console.log(nowDate);

      //当前日
      var nowDay = nowDate.getDate();
      //当前月
      var nowMonth = nowDate.getMonth();
      //当前年
      var nowYear = nowDate.getFullYear();
      nowYear += nowYear < 2000 ? 1900 : 0; //
      var lastMonthDate = new Date(); //上月日期
      lastMonthDate.setDate(1);
      lastMonthDate.setMonth(lastMonthDate.getMonth() - 1);
      //获得本月的开始日期
      var getMonthStartDate = new Date(nowYear, nowMonth, nowDay);
      date.StartDate = formatDate_MD_Month(getMonthStartDate, type);
      //获得本月的结束日期
      date.EndDate = formatDate_MD_Month_End_R(date.StartDate, type);
      console.log(date);
      return date;
    },
    formatDate_MD_Month(date, type) {
      var newNow = new Date();
      if (newNow.getHours() - 12 < 0) {
        getYesterdayDate = new Date(date.getFullYear(), date.getMonth(), date.getDate() - 1);

        var nowYear = getYesterdayDate.getFullYear();
        var nowHours = getYesterdayDate.getHours();
        var nowMinutes = getYesterdayDate.getMinutes();
        var nowSeconds = getYesterdayDate.getSeconds();
        var nowDay = getYesterdayDate.getDate();
        var nowMonth = getYesterdayDate.getMonth();

        nowYear += nowYear < 2000 ? 1900 : 0; //

        getYesterdayDate = new Date(nowYear, nowMonth, 1);
      } else {
        getYesterdayDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());

        var nowYear = getYesterdayDate.getFullYear();
        var nowHours = getYesterdayDate.getHours();
        var nowMinutes = getYesterdayDate.getMinutes();
        var nowSeconds = getYesterdayDate.getSeconds();
        var nowDay = getYesterdayDate.getDate();
        var nowMonth = getYesterdayDate.getMonth();

        nowYear += nowYear < 2000 ? 1900 : 0; //

        getYesterdayDate = new Date(nowYear, nowMonth, 1);
      }

      var myyear = getYesterdayDate.getFullYear();
      var mymonth = getYesterdayDate.getMonth() + 1;
      var myweekday = getYesterdayDate.getDate();

      if (mymonth < 10) {
        mymonth = "0" + mymonth;
      }

      if (myweekday < 10) {
        myweekday = "0" + myweekday;
      }

      if (type) {
        return myyear + "-" + mymonth + "-" + myweekday;
      } else {
        return myyear + "-" + mymonth + "-" + myweekday + " 00:00:00";
      }
      //return (myyear+"/"+mymonth + "/" + myweekday + " " + myHours+ ":" + myMinutes);
    },
    openOnlineCustomPopup() {
      this.showOnlineCustomPopup = true;
    },
    closeOnlineCustomPopup() {
      this.onlinePopupOpened = false;
      this.showOnlineCustomPopup = false;
    },
  },
  created() {
    self = this;
    self.getMerchantInfoDetail();
    this.getDepositQAListEvent();
  },
  mounted() {
    this.updateTime(); // Call updateTime() when the component is mounted
    this.intervalId = setInterval(this.updateTime, 1000); // Update time every second
  },
  beforeDestroy() {
    clearInterval(this.intervalId);
  },
  updated() {},
};
</script>
<style lang="less" scoped>
.online-cs-info {
  --f7-page-toolbar-bottom-offset: 0;
  .qaimg {
    width: 95%;
    margin: auto;
    border-radius: 5px;
    text-align: center;
    margin-top: 10px;
    img {
      border-radius: 5px;
      max-width: 100%;
      max-height: 100%;
      width: 100px;
      height: auto;
      min-width: 100%;
      min-height: 100%;
    }
  }

  .accordion-list {
    //background-color: #EEEEEE;
    margin-top: 20px;
    border-radius: 5px;
    width: 100%;
    margin: auto;
    .accordion-item {
      border-bottom: 1px solid #f0f0f0;
      .col-title {
        position: relative;
        .help {
          position: absolute;
          left: 0px;
          border-radius: 5px;
          width: 19px;
          height: auto;
          vertical-align: middle;
        }
        .s-title {
          width: 94%;
          margin-left: 15px;
          margin-top: -1px;
          font-size: 15px;
          color: #464646;
          text-decoration: underline;
          word-break: break-all;
          word-wrap: break-word;
        }
        .accordion-item-content {
          .ans {
            width: 100%;
            margin-left: 10px 10px 10px 10px;
            // word-break: break-all;
            // word-wrap: break-word;
          }
        }
      }
    }
  }
  .curr-time {
    text-align: center;
    margin-top: 5px;
    font-size: 15px;
    color: #404040;
  }
  .button-save {
    margin: 10px 0px;

    ul {
      background: var(--f7-button-bg-color);
      li {
        a {
          color: var(--f7-button-text-color);
        }
      }
    }
  }
}
</style>
